import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class UserSyncService {
  readonly #baseUrl = `${environment.azureAd.apiConfig.uri}/employees`;
  readonly #http = inject(HttpClient);

  /**
   * Calls the backend to ensure the authenticated user exists in de app DB.
   *  The backend checks on the oid from the JWT token.
   *  If the user does not exist, it creates it.
   *
   * Returns an Observable (not async/firstValueFrom) intentionally: the bootstrap
   * flow subscribes once and does not need a reloadable service-level resource.
   */
  sync(): Observable<void> {
    return this.#http.post<void>(`${this.#baseUrl}/sync`, {});
  }
}
